import { connect } from 'react-redux';

import {
  getAssetForContent
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import SlideshowThumbnail from './slideshow_thumbnails_nav.thumbnail.jsx';

const mapStateToProps = (state, { contentItem }) => {
  const asset = getAssetForContent(state, contentItem);
  const imgSrc = contentItem.thumbnail || (asset && asset.thumbnail);

  return { imgSrc };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SlideshowThumbnail);
